<template>
  <div class="container">
    <div class="manage">
      <div class="top-box">
        <div class="flexrbc">
          <div class="flexr0c">
            <div class="title-label"></div>
            <div class="title">违约仲裁</div>
          </div>
        </div>
      </div>
      <div class="search-box flexr0c">
        <div class="input">
          <Input v-model="keyword" placeholder="请输入客户名称" size="large" style="width: auto">
          <Icon type="ios-search" slot="suffix" />
          </Input>
        </div>
        <div class="btn" @click="search" :loading="searchLoad">查询</div>
      </div>
      <div class="table-box">
        <div class="table">
          <Table max-height="" ref="selection" :loading="loading" border stripe :columns="tableHead" :data="tableData"></Table>
          <div style="margin: 10px; overflow: hidden">
            <div style="float: right">
              <Page :total="total" :page-size="pageSize" :current="1" @on-change="changePage" show-elevator show-total> </Page>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mask" v-show="agreeModal">
      <div v-show="agreeModal" class="pop1-box">
        <div class="top flexrcc">
          <div class="title">协议条款</div>
        </div>
        <div class="content">
          <iframe :src="agree" class="iframe"></iframe>
        </div>
        <div class="bottom flexrcc">
          <Button type="primary" :disabled="disabled" @click="next">
            <span v-show="countDown > 0">{{ countDown }}s</span>
            <span>我已阅读</span>
          </Button>
        </div>
      </div>
    </div>
    <Modal :closable="false" v-model="applyModal" title="违约仲裁" width="350">
      <div class="applyModal">
        <div class="title-box">
          <span>*</span>
          <div class="title">违约金金额</div>
        </div>
        <input type="text" v-model="amount" class="name-input" />
        <span>元</span>
      </div>
      <div slot="footer">
        <div style="display: flex;justify-content: center;">
          <Button style="width: 138px;" @click="cancelModal">取消</Button>
          <Button style="width: 138px;background-image: linear-gradient(180deg, #478EE9 0%, #2255CE 100%);color: white;" :loading="applyLoading" @click="handleApply">确认</Button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: 'arbitrate',
  data () {
    return {
      tableData: [],
      pageSize: 8,
      keyword: '',
      tableHead: [
        {
          title: '客户名称',
          key: 'buyerName',
          resizable: true
        },
        {
          title: '手机号',
          key: 'buyerPhone',
          resizable: true
        },
        {
          title: '平台余额(元)',
          key: 'balance',
          resizable: true
        },
        {
          title: '期初余额(元)',
          key: 'txInitMoney',
          resizable: true
        },
        {
          title: '货款余额(元)',
          key: 'goodsMoney',
          resizable: true
        },
        {
          title: '操作',
          slot: 'action',
          width: 80,
          fixed: 'right',
          render: (h, params) => {
            if (params.row.goodsMoney != 0) {
              return h('div', [
                h(
                  'Button',
                  {
                    props: {
                      type: 'warning',
                      size: 'small'
                    },
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        this.buyerId = params.row.buyerId;
                        this.showModal();
                      }
                    }
                  },
                  '申请'
                )
              ]);
            }
          }
        }
      ],
      page: 1,
      total: 0,
      agreeModal: false,
      disabled: true,
      countDown: 5,
      applyModal: false,
      applyLoading: false,
      type: '2',
      buyerId: '',
      agree: '',
      amount: null,
      loading: false,
      searchLoad: false
    };
  },
  created () {
    this.getPage();
    this.getAgree();
  },
  methods: {
    search () {
      this.searchLoad = true;
      this.getPage();
    },
    cancelModal () {
      this.applyModal = false;
      this.amount = null;
    },
    getAgree () {
      const session = JSON.parse(localStorage['session']);
      this.$http
        .post({
          modeCode: '131yMyVCX9oMq8Ix1G6TyyFcoffpQPOW',
          sessionId: session.sessionId,
          userId: session.userId
        })
        .then((res) => {
          if (res.code == 1) {
            this.agree = res.data;
          } else {
            this.$Message['error']({
              background: true,
              content: res.msg
            });
          }
        });
    },
    timerCount () {
      if (this.countDown > 0) {
        setTimeout(() => {
          this.countDown -= 1;
          this.timerCount();
        }, 1000);
      } else if (this.countDown == 0) {
        this.disabled = false;
      }
    },
    next () {
      if (!this.disabled) {
        this.agreeModal = false;
        this.countDown = 5;
        this.disabled = true;
        this.applyModal = true;
      }
    },
    showModal () {
      this.agreeModal = true;
      this.timerCount();
    },
    changePage (page) {
      this.page = page;
      this.getPage();
    },
    getPage () {
      const session = JSON.parse(localStorage['session']);
      let data = {
        sessionId: session.sessionId,
        userId: session.userId,
        enterpriseId: session.enterpriseId,
        modeCode: 'HMuYOFDezCfHlLRQzRKLgCVn8xE6JJF2',
        keyword: this.keyword,
        pageIndex: this.page,
        pageSize: this.pageSize
      };
      this.loading = true;
      this.$http.post(data).then((res) => {
        this.searchLoad = false;
        this.loading = false;
        if (res.code == 1) {
          this.total = res.count;
          this.tableData = res.result_ctn;
        } else {
          this.$Message['error']({
            background: true,
            content: res.msg
          });
        }
      });
    },
    handleApply () {
      if (!this.amount) {
        this.$Message['error']({
          background: true,
          content: '请输入违约金金额!'
        });
        return;
      }
      // 大于0的两位小数
      const reg = /^0\.([1-9]|\d[1-9])$|^[1-9]\d{0,8}\.\d{0,2}$|^[1-9]\d{0,8}$/;
      const amountReg = reg.test(this.amount);
      if (amountReg) {
        this.applyLoading = true;
        const session = JSON.parse(localStorage['session']);
        this.$http
          .post({
            modeCode: 'FmKyZHTm9J2tklt7tpEU6L7O2OlRXyu5',
            sessionId: session.sessionId,
            userId: session.userId,
            enterpriseId: session.enterpriseId,
            buyerId: this.buyerId,
            amount: this.amount
          })
          .then((res) => {
            this.applyLoading = false;
            this.applyModal = false;
            if (res.code == 1) {
              this.$Message['success']({
                background: true,
                content: '操作成功！'
              });
              this.getPage();
            } else {
              this.$Message['error']({
                background: true,
                duration: 3,
                content: res.msg
              });
            }
          });
      } else {
        this.$Message['error']({
          background: true,
          content: '请输入正确的金额!'
        });
      }
    }
  }
};
</script>

<style scoped lang="less">
.container {
  width: 980px;
  text-align: center;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  margin-left: 20px;
  background: #f2f3f5;

  .manage {
    .top-box {
      background-image: linear-gradient(180deg, #ffffff 0%, #e8e9ea 100%);
      border-radius: 10px 10px 0 0;
      width: 100%;
      height: 40px;

      & > div {
        height: 100%;
        width: 928px;
        margin: 0 auto;
      }

      .title-label {
        width: 4px;
        height: 14px;
        background: #2c59c3;
      }

      .title {
        font-family: PingFangSC-Semibold;
        font-size: 16px;
        color: #2c59c3;
        letter-spacing: 0.4px;
        margin-left: 6px;
      }

      .addOrg {
        .btn {
          background-image: linear-gradient(180deg, #b4ec51 0%, #429321 100%);
          border-radius: 6px;
          cursor: pointer;
          width: 110px;
          height: 30px;
          line-height: 30px;
          margin: 0 4px;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #ffffff;
          letter-spacing: 0.35px;
          &:hover {
            background-image: linear-gradient(180deg, #c4ff5b 0%, #4aa824 100%);
          }
        }
      }
    }

    .search-box {
      /deep/.ivu-select-placeholder {
        text-align: start;
      }

      .filter {
        margin-top: 18px;
        margin-bottom: 14px;

        .label {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #616c84;
          margin: 0 10px 0 26px;
        }

        /deep/.ivu-date-picker-focused input,
        /deep/.ivu-date-picker-focused input {
          font-size: 14px;
        }

        /deep/.ivu-select-selected-value,
        /deep/.ivu-select-item {
          text-align: start;
        }

        /deep/.ivu-input-with-suffix {
          cursor: pointer;
        }

        /deep/.ivu-select-selection {
          height: 38px;
          background: #ffffff;
          // border: 1px solid #DFDFDF;
          box-shadow: inset 0 4px 8px 0 rgba(0, 0, 0, 0.07);
          border-radius: 8px;
        }

        /deep/.ivu-select-placeholder,
        /deep/.ivu-select-selected-value {
          height: 38px;
          line-height: 38px;
          padding-left: 24px;
          text-align: start;
        }

        /deep/.ivu-input-suffix {
          line-height: 38px;
        }

        /deep/.ivu-input-with-suffix {
          height: 38px;
          line-height: 38px;
          padding-left: 24px;
          background: #ffffff;
          // border: 1px solid #DFDFDF;
          box-shadow: inset 0 4px 8px 0 rgba(0, 0, 0, 0.07);
          border-radius: 8px;
        }

        .search-btn {
          background-image: linear-gradient(180deg, #91caff 0%, #0074d6 97%);
          border: 1px solid #006bc4;
          border-radius: 6px;
          width: 80px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #ffffff;
          letter-spacing: 0.35px;
          cursor: pointer;
          margin-left: 20px;

          &:hover {
            background-image: linear-gradient(180deg, #cce7ff 0%, #027de6 97%);
          }
        }
      }
    }

    .content-box {
      width: 980px;
      min-height: 538px;
      background: #ffffff;
      box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
      border-radius: 10px;
      overflow: hidden;

      .content {
        width: 928px;
        margin-top: 30px;

        .title-box {
          width: 928px;
          height: 40px;
          background-color: rgba(224, 229, 240, 0.3);

          .title {
            font-family: PingFangSC-Semibold;
            font-size: 16px;
            color: #8b93a7;
            flex: 1;
          }
        }

        .item-box {
          width: 928px;
          height: 80px;

          .num {
            font-family: Impact;
            font-size: 24px;
            flex: 1;
            margin: 25px 0;
            color: #2c59c3;
          }
        }

        .edit {
          .item {
            margin-left: 5px;
          }

          &:hover {
            color: #4a90e2 !important;
            cursor: pointer;
          }
        }

        /deep/ .ivu-table th {
          background-image: linear-gradient(180deg, #2f66ba 0%, #153684 100%);
          color: #fff;
        }

        /deep/ .ivu-table th:last-child {
          border-top-right-radius: 10px;
          background-image: linear-gradient(180deg, #2f66ba 0%, #153684 100%);
          color: #fff;
        }

        /deep/ .ivu-table th:first-child {
          // border-top-left-radius: 10px;
          background-image: linear-gradient(180deg, #2f66ba 0%, #153684 100%);
          color: #fff;
        }
      }
    }
  }

  .search-box {
    height: 74px;
    background-color: #f2f3f5;

    .input {
      margin: 0 10px 0 26px;
    }

    .btn {
      background-image: linear-gradient(180deg, #91caff 0%, #0074d6 97%);
      border: 1px solid #006bc4;
      border-radius: 6px;
      width: 80px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #ffffff;
      letter-spacing: 0.35px;
      cursor: pointer;

      &:hover {
        background-image: linear-gradient(180deg, #cce7ff 0%, #027de6 97%);
      }
    }
  }

  .table-box {
    background: #ffffff;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    border-radius: 10px;
    min-height: 534px;
    overflow: hidden;

    .table {
      width: 928px;
      margin: 25px auto;

      /deep/.ivu-table-cell {
        padding-left: 12px;
        overflow: unset;
      }

      .icon-box:hover {
        color: #4a90e2 !important;
      }

      .icon-box {
        & > div {
          margin-right: 11px;
          position: relative;
          cursor: pointer;
        }

        .tips {
          position: absolute;
          left: 10px;
          top: -10px;
          width: 30px;
          height: 15px;
          line-height: 15px;
          font-family: PingFangSC-Regular;
          font-size: 12px;
          background-color: #ffffff;
          color: #9b9b9b;
          letter-spacing: 0;
        }
      }
    }
  }

  .mask {
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.6);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;

    .pop1-box {
      position: absolute;
      width: 650px;
      min-height: 560px;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      z-index: 2;

      .top {
        width: 100%;
        height: 46px;
        background-image: linear-gradient(180deg, #5792e3 0%, #2c59c3 100%);
        border-radius: 10px 10px 0 0;

        .title {
          font-family: PingFangSC-Semibold;
          font-size: 18px;
          color: #ffffff;
          letter-spacing: 0.34px;
        }

        img {
          position: absolute;
          float: right;
          width: 16px;
          height: 16px;
          right: 15px;
          cursor: pointer;
        }
      }

      .content {
        width: 100%;
        height: 460px;
        background: #fff;
        overflow-y: scroll;
        font-size: 14px;
        box-sizing: border-box;
        padding: 10px;
        text-align: left;
        color: #252a37;
        .title {
          font-family: PingFangSC-Semibold;
          font-size: 18px;
          text-align: center;
          font-weight: 600;
        }
      }

      .bottom {
        background: #f5f5f5;
        border-radius: 0 0 10px 10px;
        height: 50px;
      }
    }
  }

  .iframe {
    width: 100%;
    outline: none;
    border: 0;
  }

  /deep/.ivu-table-wrapper-with-border {
    border-radius: 12px;
  }

  /deep/.ivu-select-selected-value,
  /deep/.ivu-select-item {
    text-align: start;
    border-bottom: 1px solid #fafafa;
  }

  /deep/span.ivu-select-selected-value {
    border-bottom: none;
  }

  /deep/.ivu-select-item:last-child {
    border-bottom: none;
  }

  /deep/.ivu-radio-checked {
    color: #2c59c3;
  }

  /deep/.ivu-table-stripe .ivu-table-body tr:nth-child(2n) td,
  .ivu-table-stripe .ivu-table-fixed-body tr:nth-child(2n) td {
    background-color: rgba(236, 241, 247, 0.4);
  }

  /deep/.ivu-table-stripe .ivu-table-body tr.ivu-table-row-hover td,
  .ivu-table-stripe .ivu-table-fixed-body tr.ivu-table-row-hover td {
    background: rgba(255, 255, 235, 0.15) !important;
  }

  /deep/.ivu-table-row-hover {
    background: rgba(255, 255, 235, 0.15) !important;
  }

  /deep/.ivu-input-with-suffix {
    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.07);
  }

  /deep/.ivu-table-wrapper-with-border {
    border-radius: 12px;
    border: 1px solid #dcdee2;
    border-right: none;
  }

  /deep/.ivu-table td,
  .ivu-table th {
    border-bottom: none;
  }

  /deep/.ivu-table:before {
    display: none;
  }

  input:disabled {
    border: 1px solid rgba(118, 118, 118, 0.3);
    box-shadow: none;
  }

  /deep/.ivu-input-wrapper {
    width: 100%;
  }
}

/deep/ .vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;

  .ivu-modal {
    top: 0;
  }
}

.name-input {
  margin: 0 5px;
  height: 48px;
  border-radius: 8px;
  padding-left: 24px;
}

.title-box {
  margin: 14px 0 8px 0;
  display: flex;
  span {
    color: #d0021b;
  }

  .title {
    font-family: PingFangSC-Semibold;
    font-size: 16px;
    color: #9097a9;
    letter-spacing: 0.3px;
    line-height: 22px;
  }
}

.applyModal {
  display: flex;
  align-items: center;
  span:first-child {
    margin-right: 10px;
  }
}
</style>
